// @ts-nocheck
function s(v) {
  return v == null ? '' : String(v).trim();
}

/** Display name — same sources we can infer as Profile + common API shapes. */
export function pickDisplayName(d) {
  if (!d || typeof d !== 'object') return '';
  const c = d.contact || d.Contact || {};
  if (s(d.User_Name__c)) return s(d.User_Name__c);
  if (s(d.Name)) return s(d.Name);
  if (s(d.name)) return s(d.name);
  if (s(d.fullName)) return s(d.fullName);
  if (s(c.name)) return s(c.name);
  if (s(c.Name)) return s(c.Name);
  const fn = s(c.FirstName || d.FirstName);
  const ln = s(c.LastName || d.LastName);
  if (fn || ln) return `${fn} ${ln}`.trim();
  return '';
}

export function pickSeniority(d) {
  if (!d || typeof d !== 'object') return '';
  const pe = d.portalEng || {};
  return s(d.Seniority__c || d.seniority || pe.seniority);
}

export function pickJobTitle(d) {
  if (!d || typeof d !== 'object') return '';
  const pe = d.portalEng || {};
  return s(
    d.Job_Title__c ||
      d.Title ||
      d.JobTitle__c ||
      d.jobTitle ||
      pe.jobTitle,
  );
}

export function pickCompany(d) {
  if (!d || typeof d !== 'object') return '';
  const c = d.contact || d.Contact || {};
  return s(c.companyName || c.Company || d.companyName || d.Company__c || d.company);
}

/**
 * Same field mapping as Profile (portal engagement from profile/getdata or cached reqData).
 */
export function parseDashboardProfilePayload(d) {
  if (!d || typeof d !== 'object') {
    return { fullName: '', seniority: '', jobTitle: '', company: '' };
  }
  return {
    fullName: pickDisplayName(d),
    seniority: pickSeniority(d),
    jobTitle: pickJobTitle(d),
    company: pickCompany(d),
  };
}

/**
 * profile/getdata (and Redux PROFILE_SUCCESS) may return the envelope
 * `{ status, data: { User_Name__c, ... } }`, a flat record, `DATA`, or nested `data.data`.
 */
export function extractProfileRecordFromApiResponse(res) {
  if (res == null || typeof res !== 'object') return null;

  if (res.DATA && typeof res.DATA === 'object') {
    return extractProfileRecordFromApiResponse(res.DATA);
  }

  const inner = res.data;
  if (inner && typeof inner === 'object') {
    if (inner.data && typeof inner.data === 'object') {
      const deep = extractProfileRecordFromApiResponse(inner.data);
      if (deep) return deep;
    }
    if (
      inner.User_Name__c != null ||
      inner.contact ||
      inner.Contact ||
      inner.Job_Title__c != null ||
      inner.Seniority__c != null ||
      inner.Name != null
    ) {
      return inner;
    }
    if (Object.keys(inner).length > 0) {
      return inner;
    }
  }

  if (res.payload && typeof res.payload === 'object') {
    return extractProfileRecordFromApiResponse(res.payload);
  }

  if (
    res.User_Name__c != null ||
    res.contact ||
    res.Contact ||
    res.Job_Title__c != null ||
    res.Seniority__c != null ||
    res.Name != null
  ) {
    return res;
  }

  return null;
}

/** Treat 1 / "1" as success; missing `status` means a raw record (not an envelope). */
export function isApiSuccessEnvelope(res) {
  if (res == null || typeof res !== 'object') return false;
  if (!Object.prototype.hasOwnProperty.call(res, 'status')) return true;
  const st = res.status;
  return st === 1 || st === '1';
}

export function mergeDashboardProfileParts(a, b) {
  return {
    fullName: s(a.fullName) || s(b.fullName),
    seniority: s(a.seniority) || s(b.seniority),
    jobTitle: s(a.jobTitle) || s(b.jobTitle),
    company: s(a.company) || s(b.company),
  };
}
